import React, { useState, useEffect, useRef } from "react";
import "./ReviewSlideshow.css";

const ReviewSlideshow = ({ review_slideshow_filedata, banner_default }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlay, setIsAutoPlay] = useState(true);
  const intervalRef = useRef(null);

  // Auto-change slides
  useEffect(() => {
    if (isAutoPlay && review_slideshow_filedata?.length > 0) {
      intervalRef.current = setInterval(() => {
        setCurrentSlide((prev) =>
          prev === review_slideshow_filedata.length - 1 ? 0 : prev + 1
        );
      }, 4000);
    }
    return () => clearInterval(intervalRef.current);
  }, [isAutoPlay, review_slideshow_filedata]);

  // If no data, render nothing
  if (!review_slideshow_filedata || review_slideshow_filedata.length === 0) {
    return null;
  }

  const handleDotClick = (index) => {
    setCurrentSlide(index);
    setIsAutoPlay(false); // stop auto-play when user clicks
  };

  return (
    <div className="slideshow-container">
      {review_slideshow_filedata.map((row, index) => (
        <img
          key={index}
          src={row.url || banner_default}
          alt={`slide-${index}`}
          className={`slide ${index === currentSlide ? "active" : ""}`}
        />
      ))}

      {/* Dots Navigation */}
      <div className="dots-container">
        {review_slideshow_filedata.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentSlide ? "active" : ""}`}
            onClick={() => handleDotClick(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default ReviewSlideshow;
